import { render, staticRenderFns } from "./TalkInfo.vue?vue&type=template&id=4d771df9&scoped=true&"
import script from "./TalkInfo.vue?vue&type=script&lang=js&"
export * from "./TalkInfo.vue?vue&type=script&lang=js&"
import style0 from "./TalkInfo.vue?vue&type=style&index=0&id=4d771df9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d771df9",
  null
  
)

export default component.exports